module.exports = __webpack_public_path__ + "static/img/040903.34276ce5.png";